import type { Phrases } from '../../types';

type ElementsSetterParams = {
  nodes: Element[];
  phrases: Phrases;
  attributeName: string;
};

export function elementsSetter({
  nodes,
  phrases,
  attributeName
}: ElementsSetterParams) {
  nodes.forEach((node, i) => {
    node.setAttribute(attributeName, phrases[i]);
  });
}
